// subscription.js

// This function will run once the entire HTML document is loaded and parsed.
document.addEventListener('DOMContentLoaded', () => {
    // Check if the Stripe library has been loaded.
    if (typeof Stripe === 'undefined') {
        console.error('Stripe.js has not been loaded. Subscription form will not work.');
        return;
    }

    // Initialize Stripe with your public key.
    const stripe = Stripe("pk_live_p7xbpYnD5LTnlcY9m9WbpUPD");
    const elements = stripe.elements();
    
    // Create and mount the Card Element.
    const card = elements.create("card", { 
        style: { 
            base: { 
                fontSize: "16px",
                color: "#1A1D26", // Match text color from CSS variables
                '::placeholder': {
                    color: "#5A6475", // Match secondary text color
                },
            } 
        } 
    });
    
    const cardElement = document.getElementById("card-element");
    if (cardElement) {
        card.mount("#card-element");
    } else {
        console.error('Stripe card element container #card-element not found.');
        return;
    }

    // Handle real-time validation errors from the card Element.
    card.on("change", (event) => {
        const displayError = document.getElementById("card-errors");
        if (displayError) {
            displayError.textContent = event.error ? event.error.message : "";
        }
    });

    // --- Make the core functions available globally ---
    // This allows the onclick attributes in the HTML to find these functions.
    window.stripe = stripe;
    window.card = card;
    window.buyNow = buyNow;
    window.showReceipt = showReceipt;
});


// This function is called after a successful payment to notify the backend.
async function postSignup(data) {
    try {
        await fetch("https://n8n.riptec.host/webhook/f0551dd7-8f07-4600-8441-aa31ab14e98b/webhook", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        });
    } catch (err) {
        console.warn("Post-signup webhook failed:", err);
    }
}


// This is the main function that handles the payment process.
async function buyNow(plan) {
    const statusBox = document.getElementById("mpwr-status");
    statusBox.textContent = "Processing...";
    const cusName = document.getElementById("cus-name").value || "Anonymous";
    const cusEmail = document.getElementById("cus-email").value || "";
    const coupon = document.getElementById("coupon").value || "";

    const payload = {
        product: "M-Pwr Personal Assistant", plan, amount: plan === "monthly" ? 80 : 800,
        currency: "GBP", cus_name: cusName, cus_email: cusEmail, coupon
    };

    try {
        const res = await fetch("https://n8n.riptec.host/webhook/m-pwr_buy_now", {
            method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
        });
        if (!res.ok) throw new Error("Webhook failed");
        let data = await res.json();
        if (Array.isArray(data)) data = data[0];

        // Coupon Error Handler
        if (data && data.status === 'not_found') {
            statusBox.textContent = `❌ ${data.coupon || 'Invalid Coupon Code.'}`;
            return;
        }

        // Handle free coupon/bypass scenario
        if (data.mode === "bypass" && data.status === "success") {
            const resultPayload = {
                product: payload.product, plan, cus_name: cusName, cus_email: cusEmail, coupon,
                description: data.description || "Discount applied - no charge", amount: 0, currency: payload.currency,
                mode: "bypass", payment_id: "FREE-" + Date.now(), status: "success", timestamp: new Date().toISOString(),
                receipt_url: null, card_brand: null, card_last4: null
            };
            showReceipt(resultPayload);
            postSignup(resultPayload);
            return;
        }

        if (!data.client_secret) throw new Error("No client_secret from n8n");

        // Confirm the card payment with Stripe
        const result = await window.stripe.confirmCardPayment(data.client_secret, {
            payment_method: { card: window.card, billing_details: { name: cusName, email: cusEmail } }
        });

        if (result.error) {
            statusBox.textContent = " ❌ Payment failed: " + result.error.message;
            return;
        }

        if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
            const pi = result.paymentIntent;
            let chargeDetails = {};

            try {
                // Call webhook to get receipt details on-demand
                const detailsRes = await fetch("https://n8n.riptec.host/webhook/get-payment-details", {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ payment_intent_id: pi.id })
                });
                if (detailsRes.ok) {
                    chargeDetails = await detailsRes.json();
                    if (Array.isArray(chargeDetails)) chargeDetails = chargeDetails[0];
                }
            } catch (err) {
                console.warn("Could not fetch receipt details from backend.", err);
            }

            const resultPayload = {
                plan, cus_name: cusName, cus_email: cusEmail, coupon, product: payload.product,
                description: pi.description, amount: pi.amount, currency: pi.currency, mode: "stripe",
                payment_id: pi.id, status: "success", timestamp: new Date().toISOString(),
                receipt_url: chargeDetails.receipt_url || null,
                card_brand: chargeDetails.card_brand || null,
                card_last4: chargeDetails.card_last4 || null
            };
            showReceipt(resultPayload);
            postSignup(resultPayload);
        } else {
            statusBox.textContent = " ❌ Payment not confirmed.";
        }
    } catch (err) {
        statusBox.textContent = "Error: " + err.message;
    }
}

// This function hides the form and displays the final receipt.
function showReceipt(data) {
    const signupView = document.getElementById('signup-view');
    if (signupView) {
        signupView.style.display = "none";
    }

    const product = data.product || "Unknown Product", plan = data.plan || "", cusName = data.cus_name || "Anonymous",
          cusEmail = data.cus_email || "", coupon = data.coupon || "None", description = data.description || "",
          amount = typeof data.amount === "number" ? data.amount : Number(data.amount) || 0,
          currency = (data.currency || "gbp").toUpperCase(), paymentId = data.payment_id || "N/A",
          created = data.timestamp ? new Date(data.timestamp).toLocaleString() : new Date().toLocaleString(),
          status = data.status || "success", cardBrand = data.card_brand || null, cardLast4 = data.card_last4 || null,
          receiptUrl = data.receipt_url || null;
    
    const receiptHtml = `
    <div class="mpwr-receipt">
        <img src="https://conxion.host/wp-content/uploads/2025/09/m-pwr_logo02.png" alt="M-Pwr Logo" class="mpwr-logo" style="margin-bottom: 1em;">
        <h3 class="mpwr-title" style="margin-bottom: 1.5em;">Payment Receipt</h3>
        <p><strong>Product:</strong> ${product}</p>
        <p><strong>Plan:</strong> ${plan}</p>
        <p><strong>Customer:</strong> ${cusName} (${cusEmail})</p>
        <p><strong>Coupon:</strong> ${coupon}</p>
        <p><strong>Description:</strong> ${description}</p>
        <p><strong>Amount Paid:</strong> £${(amount/100).toFixed(2)} ${currency}</p>
        <p><strong>Transaction ID:</strong> ${paymentId}</p>
        ${cardBrand && cardLast4 ? `<p><strong>Card:</strong> ${cardBrand.toUpperCase()} •••• ${cardLast4}</p>` : ""}
        <p><strong>Status:</strong> ${status}</p>
        <p><strong>Date:</strong> ${created}</p>
        ${receiptUrl ? `<p><a href="${receiptUrl}" target="_blank"> 🔗 View Stripe Receipt</a> | <a href="${receiptUrl}?download=1" target="_blank"> ⬇️ Download PDF</a></p>` : ""}
        <hr>
        <p>Thank you for your purchase!</p><br>
        <p>Our team are aware of your order, and are busy setting up your M-Pwr service. We will be in touch shortly!</p>
    </div>`;

    // We append the receipt to the main content area of the auth panel
    const mainAuthContent = document.querySelector('.auth-panel-main');
    if (mainAuthContent) {
        mainAuthContent.innerHTML = receiptHtml; // Replace the forms with the receipt
    } else {
        document.body.insertAdjacentHTML("beforeend", receiptHtml); // Fallback
    }
}